/**
 * A new release of the portal, taken without losing anyone's work (P-37, #125). The service worker of a new release
 * used to reload every open tab the moment it took over (vite-plugin-pwa's autoUpdate): on Kalley Residence it reloaded
 * the page between sheet 2 and sheet 3 of a drawing set being split, and the set stopped there. Now the page goes on as
 * it is, and the new release is loaded at the next page change, never while work that runs in the page holds it (a set
 * splitting into plates). A form with changes not saved asks before the page changes (unsaved.ts), so it is safe too.
 */

let waiting = false;
let holds = 0;

/** The service worker of a new release has taken over: load it at the next page change. */
export function newVersion(): void {
  waiting = true;
}

/** Work in the page that a reload would cut short; let go when it ends (once, however often it is called). */
export function holdUpdate(): () => void {
  holds += 1;
  let held = true;
  return () => {
    if (!held) return;
    held = false;
    holds -= 1;
  };
}

/** Whether the page loads the new release now, as it changes to another page. */
export const reloadsAtPageChange = (): boolean => waiting && holds === 0;
